import React from 'react';

export const ChevronUp = ({ color = '#F8F8FD' }: { color: string }) => (
  <svg width="100%" height="100%" viewBox="0 0 56 57" fill="none">
    <path d="M40 34.8345L28 22.8345L16 34.8345" stroke={color} strokeWidth="2" />
  </svg>
);
